// Écrans affichés pendant la vérification de session ou si le serveur est injoignable.
import React from "react";
import { Spinner } from "../shared/ui/Spinner";
import { FONTS, NW } from "../shared/ui/tokens";

const screen: React.CSSProperties = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 16,
  background: NW.gray50,
  fontFamily: FONTS.body,
  color: NW.gray700,
  padding: 16,
  textAlign: "center",
};

const button = (primary: boolean): React.CSSProperties => ({
  padding: "9px 20px",
  borderRadius: 10,
  border: primary ? "none" : `1.5px solid ${NW.gray300}`,
  background: primary ? NW.violet : NW.white,
  color: primary ? NW.white : NW.gray700,
  fontFamily: FONTS.body,
  fontWeight: 700,
  fontSize: 14,
  cursor: "pointer",
});

export const SessionChecking: React.FC = () => (
  <div style={screen}>
    <Spinner size={32} thickness={3} />
    <span>Vérification de la session…</span>
  </div>
);

export const ServerUnreachable: React.FC<{
  onRetry: () => void;
  onLogout: () => void;
}> = ({ onRetry, onLogout }) => (
  <div style={screen}>
    <strong style={{ fontFamily: FONTS.heading, fontSize: 18, color: NW.gray800 }}>
      Serveur inaccessible
    </strong>
    <span>Impossible de vérifier votre session. Votre connexion est conservée.</span>
    <div style={{ display: "flex", gap: 10 }}>
      <button style={button(true)} onClick={onRetry}>
        Réessayer
      </button>
      <button style={button(false)} onClick={onLogout}>
        Se déconnecter
      </button>
    </div>
  </div>
);
